/*
 * @Author: Dong
 * @Date: 2022-04-19 13:13:53
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-10-28 13:29:17
 */
import React from 'react';
import { Modal, Button } from 'sup-ui';
import _confirm from 'sup-ui/lib/modal/confirm';
import { ModalProps } from 'sup-ui/lib/modal';
import Icon from '../Icon';
import './index.less';

export interface CustomModalProps extends ModalProps {
  btnAlgin?: string;
  height?: string;
}

const defaultProps = {
  okText: '确定',
  cancelText: '取消',
  btnAlgin: 'right',
};

class CommonModal extends React.Component<CustomModalProps> {
  static confirm(props: any) {
    const config = {
      type: 'confirm',
      okCancel: true,
      icon: <Icon className="supicon" type="tixing40" />,
      className: 'custom-confirm',
      cancelText: '取消',
      okText: '确认',
      okButtonProps: { size: 'small' },
      cancelButtonProps: { size: 'small' },
      width: '340px',
      ...props,
    };
    return _confirm(config);
  }

  getFooter = () => {
    const { btnAlgin, cancelText, okText, onOk, onCancel, footer, okButtonProps }: CustomModalProps = {
      ...defaultProps,
      ...this.props,
    };

    if (footer) return footer;

    return (
      <div className={btnAlgin}>
        <Button type="primary" onClick={onOk} {...okButtonProps}>
          {okText}
        </Button>
        <Button onClick={onCancel}>{cancelText}</Button>
      </div>
    );
  };

  render() {
    const { className, btnAlgin, footer, height, ...resets } = this.props;
    const footerRes = this.getFooter();

    return (
      <Modal
        {...resets}
        maskClosable={false}
        className={`${className ? className : ''} ${height === 'auto' ? 'auto' : 'custom-modal '}`}
        footer={footerRes}
      >
        {this.props.children}
      </Modal>
    );
  }
}

export default CommonModal;
